module.exports = __webpack_public_path__ + "c55f272afa169d8af20c0adb564f4e45.pdf";